interface Props {
  small?: boolean;
}

const SvgAddToCard: React.FC<Props> = ({ small }) => {
  return (
    <>
      {small ? (
        <svg
          style={{ marginTop: -2 }}
          width="15"
          height="14"
          viewBox="0 0 15 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_1018_5966)">
            <path
              d="M1.52082 1.75C1.46284 1.74918 1.40529 1.75989 1.35149 1.78151C1.29769 1.80313 1.24872 1.83522 1.20744 1.87593C1.16615 1.91664 1.13337 1.96514 1.11099 2.01863C1.08861 2.07212 1.07709 2.12952 1.07709 2.1875C1.07709 2.24548 1.08861 2.30288 1.11099 2.35637C1.13337 2.40986 1.16615 2.45836 1.20744 2.49907C1.24872 2.53978 1.29769 2.57187 1.35149 2.59349C1.40529 2.61511 1.46284 2.62582 1.52082 2.625H2.32461C2.53692 2.625 2.71391 2.77169 2.75414 2.98047L2.84129 3.4362L3.7818 8.37573C3.95188 9.26693 4.73707 9.91667 5.6446 9.91667H11.1054C12.0129 9.91667 12.7984 9.26718 12.9682 8.37573L13.9087 3.4362C13.9207 3.37295 13.9187 3.30783 13.9027 3.24546C13.8867 3.1831 13.8571 3.12503 13.8161 3.07541C13.7751 3.02579 13.7236 2.98584 13.6654 2.9584C13.6071 2.93095 13.5435 2.91671 13.4792 2.91667H3.63255L3.61375 2.81698C3.49618 2.20078 2.95202 1.75 2.32461 1.75H1.52082ZM3.79946 3.79167H12.9505L12.1085 8.21224C12.0164 8.6963 11.5984 9.04167 11.1054 9.04167H5.6446C5.15172 9.04167 4.73405 8.69628 4.64142 8.21224V8.21167L3.79946 3.79167ZM6.33332 10.5C6.10125 10.5 5.87869 10.5922 5.7146 10.7563C5.55051 10.9204 5.45832 11.1429 5.45832 11.375C5.45832 11.6071 5.55051 11.8296 5.7146 11.9937C5.87869 12.1578 6.10125 12.25 6.33332 12.25C6.56538 12.25 6.78794 12.1578 6.95204 11.9937C7.11613 11.8296 7.20832 11.6071 7.20832 11.375C7.20832 11.1429 7.11613 10.9204 6.95204 10.7563C6.78794 10.5922 6.56538 10.5 6.33332 10.5ZM10.4167 10.5C10.1846 10.5 9.96203 10.5922 9.79793 10.7563C9.63384 10.9204 9.54165 11.1429 9.54165 11.375C9.54165 11.6071 9.63384 11.8296 9.79793 11.9937C9.96203 12.1578 10.1846 12.25 10.4167 12.25C10.6487 12.25 10.8713 12.1578 11.0354 11.9937C11.1995 11.8296 11.2917 11.6071 11.2917 11.375C11.2917 11.1429 11.1995 10.9204 11.0354 10.7563C10.8713 10.5922 10.6487 10.5 10.4167 10.5Z"
              fill={"currentColor"}
            />
          </g>
          <defs>
            <clipPath id="clip0_1018_5966">
              <rect width="14" height="14" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          style={{ marginTop: -4 }}
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 0.488281V1.98828H3C3.32227 1.98828 3.59766 2.19922 3.70312 2.50391L5.10352 15.002C5.23242 16.1328 6.20508 17 7.3418 17H16.5V15.5H7.3418C6.95508 15.5 6.63867 15.2188 6.59766 14.8379L6.50391 14H16.0195C17.0859 14 18.0176 13.2383 18.2285 12.1953L19.6641 5H5.49023L5.16797 2.14062L5.14453 2.07031C4.85742 1.13281 3.98438 0.49414 3 0.488281H0ZM15 17C14.1738 17 13.5 17.6738 13.5 18.5C13.5 19.3262 14.1738 20 15 20C15.8262 20 16.5 19.3262 16.5 18.5C16.5 17.6738 15.8262 17 15 17ZM7.5 17C6.67383 17 6 17.6738 6 18.5C6 19.3262 6.67383 20 7.5 20C8.32617 20 9 19.3262 9 18.5C9 17.6738 8.32617 17 7.5 17ZM5.66016 6.5H17.8359L16.7578 11.8965C16.6816 12.2539 16.3828 12.5 16.0195 12.5H6.33398L5.66016 6.5Z"
            fill={"currentColor"}
          />
        </svg>
      )}
    </>
  );
};

export default SvgAddToCard;
